import { load } from 'js-yaml';

export default function extractBaseCourse(yaml: string) {
  try {
    const content = load(yaml || '{}') as Partial<Content>;
    return content && content['base-course'] ? content['base-course'] : null;
  } catch (error) {
    console.error('Error loading yaml to extract base course:', error);
    return null;
  }
}

export function extractBaseClCourse(yaml: string) {
  try {
    const content = load(yaml || '{}') as Partial<Content>;
    return content && content['base'] ? content['base'] : null;
  } catch (error) {
    console.error('Error loading yaml to extract base cl course:', error);
    return null;
  }
}
